export const EventBus = (events: { key: string; fn: (data: unknown) => void }[] = []) => {
  const addEvent = (key: string, fn: (data: unknown) => void) => {
    const event = _events.findIndex(e => e.key === key);
    if (~event) {
      _events[event].fn = fn;
    } else {
      _events.push({ key, fn });
    }
  };

  const removeEvent = (key: string) => {
    const event = _events.findIndex(e => e.key === key);
    if (~event) {
      _events.splice(event, 1);
    }
  };

  const onEvent = (key: string, data: unknown) => {
    const event = _events.findIndex(e => e.key === key);
    if (~event) {
      _events[event].fn(data);
    }
  };

  const registeredEvents = () => _events.map(e => e.key);

  const _events: { key: string; fn: (data: unknown) => void }[] = [];
  events.forEach(e => addEvent(e.key, e.fn));

  return {
    addEvent,
    removeEvent,
    onEvent,
    registeredEvents
  };
};

export type EventBusType = ReturnType<typeof EventBus>;
